import { treatErrorAs } from 'api/errors';
import { errorLevel } from 'constants/errors';

// Finders
import { findDeviceList, findPreferredDevice, findDriveDevices } from 'devices/finders';

export const requestPreferredDevice = () => {
  return (dispatch, getState) => {

    return Promise.resolve()
    .then( () => findDeviceList({ dispatch, getState }) )
    .then(() => findPreferredDevice({ dispatch, getState }) )
    .catch( treatErrorAs({ severity: errorLevel.INFO }) );
  };
};

export const requestDriveDevices = () => {
  return (dispatch, getState) => {
    return Promise.resolve()
    .then(() => findDriveDevices({ dispatch, getState }))
    .catch(treatErrorAs({ severity: errorLevel.INFO }));
  };
};